import React, { useEffect, useState } from 'react';
import { CgClose } from 'react-icons/cg';

const MobilePromoPopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('promoDismissed')) return;
    setVisible(true);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem('promoDismissed', '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="lg:hidden fixed top-20 right-3 z-[60] w-[120px] shadow-2xl rounded-lg overflow-hidden border-2 border-amber-500 bg-white">
      <button
        type="button"
        onClick={dismiss}
        className="absolute top-1 right-1 z-10 bg-black/70 text-white rounded-full p-0.5"
        aria-label="Close promo"
      >
        <CgClose size={16} />
      </button>
      <img
        src="/dis-ban.png"
        alt="Launch Week — 20% OFF"
        className="w-full h-auto object-contain"
      />
    </div>
  );
};

export default MobilePromoPopup;
